import { useContext } from "react";
import { AccountContext } from "./Account";

const useAuth = () => {
  return useContext(AccountContext);
};

export default useAuth;
